import React, { useMemo, useState } from "react";
import dayjs from "dayjs";
import { Button, Cell, DateSelect, Input, Panel, Radio, Select } from "zarm";
import "zarm/dist/zarm.min.css";
import banner1 from "./banner1.png";
import banner2 from "./banner2.png";
import "./App.css";

const EMBRYO_TYPE_OPTIONS = [
  { value: "1", label: "移植 D5/6 囊胚" },
  { value: "2", label: "移植 D3 胚胎" },
];

const TIME_TYPE_OPTIONS = [
  { value: "1", label: "移植时间" },
  { value: "2", label: "开始使用孕酮的时间" },
];

function timeTypeLabel(value: string) {
  const val = TIME_TYPE_OPTIONS.find((o) => o.value === value);
  return val ? val.label : "";
}

function App() {
  const [embryoType, setCycleType] = useState("1");
  const [hour, setHour] = useState<number>();
  const [timeType, setTimeType] = useState("1");
  const [time, setTime] = useState<Date>();

  const resultTime = useMemo(() => {
    if (embryoType && hour && timeType && time) {
      if (embryoType === "1") {
        if (timeType === "1") {
          return dayjs(time).subtract(hour, "hour").toDate();
        } else {
          return dayjs(time).add(hour, "hour").toDate();
        }
      } else {
        if (timeType === "1") {
          return dayjs(time).subtract(hour, "hour").add(2, "day").toDate();
        } else {
          return dayjs(time).add(hour, "hour").subtract(2, "day").toDate();
        }
      }
    }
  }, [embryoType, hour, timeType, time]);

  return (
    <div className="App">
      <div style={{ padding: "15px 0", backgroundColor: "#64839a" }}>
        <div
          style={{
            marginBottom: "15px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <img src={banner1} style={{ height: "25px" }} alt="奕真生物科技" />
          <img
            src={banner2}
            style={{ marginLeft: "10px", height: "30px" }}
            alt="IGENOMIX"
          />
        </div>
        <p
          style={{
            margin: "0",
            textAlign: "center",
            fontSize: "22px",
            color: "white",
            fontWeight: "bold",
          }}
        >
          ERA 个体化胚胎移植时间计算
        </p>
      </div>
      <Cell style={{ display: "flex", justifyContent: "center" }}>
        <p className="normal">本页面仅支持激素替代周期（HRT）的时间计算</p>
      </Cell>
      <Panel title="胚胎类型">
        <Cell className="cell-input">
          <Select
            value={embryoType}
            dataSource={EMBRYO_TYPE_OPTIONS}
            onOk={(selected) => {
              setCycleType(selected[0].value);
            }}
          />
        </Cell>
      </Panel>
      <Panel title="ERA推荐囊胚移植时间：使用孕酮后（小时）">
        <Cell className="cell-input">
          <Input
            clearable
            type="number"
            placeholder="请输入"
            value={hour || ""}
            onChange={(value) => {
              setHour(parseInt(value as string) || undefined);
            }}
          />
        </Cell>
      </Panel>
      <Panel>
        <Cell style={{ marginBottom: "15px" }}>
          <Radio.Group
            value={timeType}
            block
            type="button"
            onChange={(val) => {
              setTimeType(val as string);
            }}
          >
            {TIME_TYPE_OPTIONS.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        </Cell>
        <Cell className="cell-input">
          <DateSelect
            title="选择日期时间"
            placeholder="请选择日期时间"
            mode="datetime"
            value={time}
            onOk={(value) => {
              setTime(value);
            }}
          />
        </Cell>
      </Panel>
      <Panel title={timeTypeLabel(timeType === "1" ? "2" : "1")}>
        <Cell>
          <p className="normal">
            {resultTime && dayjs(resultTime).format("YYYY-MM-DD HH:mm")}
          </p>
        </Cell>
      </Panel>
      <Panel>
        <Cell style={{ display: "flex", justifyContent: "center" }}>
          <Button
            style={{ textDecoration: "underline" }}
            href="http://lxi.me/z3000"
          >
            学术天地
          </Button>
        </Cell>
      </Panel>
    </div>
  );
}

export default App;
